import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type { CategoryItem } from "web_myplann/Portfolio/Types/portfolioCategory";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

const MONTHS_PER_PAYMENT: Partial<
	Record<ClientPortfolioPaymentFrequencyEnum, number>
> = {
	[ClientPortfolioPaymentFrequencyEnum.Monthly]: 1,
	[ClientPortfolioPaymentFrequencyEnum.Quarterly]: 3,
	[ClientPortfolioPaymentFrequencyEnum.Semiannually]: 6,
	[ClientPortfolioPaymentFrequencyEnum.Yearly]: 12,
};

export const calculateMonthlyPayment = (item: CategoryItem): number | null => {
	if (item.kind !== PortfolioItemKind.Portfolio) {
		return null;
	}

	const { payment, installment, paymentFrequency } = item.data;
	const amount = payment ?? installment;
	const months = paymentFrequency
		? MONTHS_PER_PAYMENT[paymentFrequency]
		: undefined;

	if (amount === null || amount === undefined || months === undefined) {
		return null;
	}

	return amount / months;
};
